module.exports = __webpack_public_path__ + "static/media/menu-icon.9ee1427a.svg";